import {
  FooterLinks,
  FooterContent,
  FooterContentLinks,
} from "@sentara-health/optimahealth_web";
import { useTranslation } from "react-i18next";

import { Brands, useBranding } from "../../providers";
import { FooterNavType } from "../../utils/models/CommonTypes";

export const AppFooter = () => {
  const { t } = useTranslation();
  const { brandConfig } = useBranding();

  const navigationLinks = Object.keys(brandConfig.footerNavigation).map(
    (key: string) => {
      const links = brandConfig.footerNavigation;
      const item: FooterNavType = links[key];
      if (key === "footerContactUs" && brandConfig.brandName === Brands.AVMED) {
        delete links[key];
        return;
      } else if (
        key === "footerPrivacy" &&
        brandConfig.brandName !== Brands.AVMED
      ) {
        delete links[key];
        return;
      }
      return { ...item, label: t(item.label) };
    }
  );

  return (
    <footer className="mt-auto not-print">
      {brandConfig.brandName !== Brands.AVMED ? (
        <>
          <FooterLinks links={navigationLinks} />
          <div className="footer-disclaimer-text">
            <FooterContent
              copyrightText={t("footer.label.copyrightText", {
                year: new Date().getFullYear(),
              })}
              footerDescription={t("footer.label.disclaimer")}
            />
          </div>
        </>
      ) : (
        <FooterContentLinks
          links={navigationLinks}
          copyrightText={t("footer.label.copyrightText", {
            year: new Date().getFullYear(),
          })}
          footerDescriptionLine1={t("footer.label.disclaimer")}
        ></FooterContentLinks>
      )}
    </footer>
  );
};
